import { useState } from "react"
import DatePicker from "react-multi-date-picker"
import TimePicker from "react-multi-date-picker/plugins/time_picker";
// import persian from "react-date-object/calendars/persian"
// import persian_fa from "react-date-object/locales/persian_fa"

// const getTODAY = () => {
//      let today = new Date();
//      let dd = today.getDate();
//      let mm = today.getMonth() + 1; //January is 0!
//      let yyyy = today.getFullYear();
//      let hours = today.getHours();
//      let minutes = today.getMinutes();
//      if (hours < 10) {
//           hours = '0' + hours
//      }
//      if (minutes < 10) {
//           minutes = '0' + minutes
//      }
//      if (dd < 10) {
//           dd = '0' + dd
//      }
//      if (mm < 10) {
//           mm = '0' + mm
//      }

//      return yyyy + '-' + mm + '-' + dd + 'T' + hours + ':' + minutes
// }

const PendingPost = ({ defaultValue = 0, setPendingPost, children, datePublish, setDatePublish }) => {



     const HandleOnChange = (e) => {
          setPendingPost(parseInt(e.target.value))
     }

     const handleChangeDate = (value) => {
          let year = value.year
          let month = (value.month < 10 ? '0' + value.month : value.month)
          let day = (value.day < 10 ? '0' + value.day : value.day)
          let hour = (value.hour < 10 ? '0' + value.hour : value.hour)
          let minute = (value.minute < 10 ? '0' + value.minute : value.minute)
          let second = (value.second < 10 ? '0' + value.second : value.second)
          let date = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second
          setDatePublish(date)
     }


     return (
          <>
               <div className="boxHolderPosts">
                    <div className="titleBar">وضعیت</div>
                    <div className="boxPost">

                         {children}

                         <DatePicker
                              required
                              value={datePublish}
                              format="YYYY/MM/DD HH:mm:ss"
                              placeholder='تاریخ انتشار'
                              style={{ direction: 'ltr' }}
                              plugins={[<TimePicker position="bottom" />]}
                              // calendar={persian}
                              // locale={persian_fa}
                              onChange={handleChangeDate}
                              calendarPosition="bottom-right"
                         />

                         <select value={defaultValue} onChange={HandleOnChange} style={{ width: '100%', backgroundColor: '#fff', padding: '8px', fontSize: '14px' }} name="pendingPost" id="pendingPost">
                              <option value="1">پیشنویس</option>
                              <option value="0">منتشر شده</option>
                         </select>
                    </div>
               </div>
          </>
     )
}

export default PendingPost